import moment from 'moment';

const daysDiff = (start, end = new Date()) =>
  Math.floor(moment.duration(moment(end).diff(moment(start))).asDays());

export default daysDiff;



// WEBPACK FOOTER //
// ./src/utils/daysDiff.js